const nav = document.getElementById('fullscreen-navi');
const searchToggle = document.getElementById('search-toggle');
const searchOverlay = document.getElementById('fullscreen-navi-search-overlay');
const loggedInToggle = document.getElementById('account-toggle-logged-in');
const notLoggedInToggle = document.getElementById('account-toggle-not-logged-in');
const loggedInOverlay = document.getElementById('my-orthomol-overlay-logged-in');
const notLoggedInOverlay = document.getElementById('my-orthomol-overlay-not-logged-in');
const accountOverlayCloseButtons = document.querySelectorAll('.fullscreen-navi-account-overlay-close-button');
const langToggle = document.getElementById('language-toggle');
const langDropdown = document.getElementById('image-dropdown');
const menuToggle = document.getElementById('menu-toggle');
const menuOverlay = document.getElementById('menu-overlay');

// Function to get current size
function getCurrentSize() {
  return window
    .getComputedStyle(document.getElementById('fullscreen-navi'))
    .getPropertyValue('content')
    .replace(/'|"/g, '');
}

// Trap overlays in focus
function getFocusableElements(container) {
    const focusableSelectors = 'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';
    return Array.from(container.querySelectorAll(focusableSelectors))
        .filter(el => {
            if (el.offsetParent === null) return false;

            if (el.classList.contains('tt-hint')) return false;
            return true;
        });
}

// move language switch element to correct position depending on device size
function setLanguageSwitchPosition() {
  const language = document.querySelector('.fullscreen-navi-language');
  const currentSize = getCurrentSize();
  if (!language || !langToggle) return;
  switch(currentSize) {
    case 'tablet':
      const highlights = document.querySelector('.fullscreen-navi-overlay-highlight');
      if (highlights) {
        highlights.appendChild(language);
        openLangMenu();
        langToggle.disabled = true;
      } else {
        document.querySelector('.fullscreen-navi-overlay-inner').appendChild(language);
        openLangMenu();
        langToggle.disabled = true;
      }
      break;
    case 'mobile':
      document.querySelector('.fullscreen-navi-overlay').appendChild(language);
      openLangMenu();
      langToggle.disabled = true;
      break;
    default:
    document.getElementById('menu-toggle').before(document.querySelector('.fullscreen-navi-language'));
    langToggle.disabled = false;
    closeLangMenu();
    break;
  }
  language.classList.remove('d-none');
}

// Search overlay functions
function openSearchOverlay() {
    const isMenuExpanded = menuToggle.getAttribute('aria-expanded') === 'true';
    const loggedInExpanded = loggedInToggle ?  loggedInToggle.getAttribute('aria-expanded') === 'true' : false;
    const notLoggedInExpanded = notLoggedInToggle ?  notLoggedInToggle.getAttribute('aria-expanded') === 'true' : false;
    const focusables = getFocusableElements(searchOverlay);

    if (loggedInExpanded) {
        closeAccountOverlay(loggedInToggle, loggedInOverlay);
    }
    if (notLoggedInExpanded) {
        closeAccountOverlay(notLoggedInToggle, notLoggedInOverlay);
    }
    if (isMenuExpanded) {
        closeMenuOverlay();
    }
    nav.classList.add('inverted');
    searchToggle.setAttribute('aria-expanded', 'true');
    searchToggle.classList.add('inverted');
    searchOverlay.classList.add('overlay-open');

    // Focus the search input after opening the overlay
    setTimeout(() => { focusables[0]?.focus() }, 300)
}

function closeSearchOverlay() {
    nav.classList.remove('inverted');
    searchToggle.setAttribute('aria-expanded', 'false');
    searchToggle.classList.remove('inverted');
    searchOverlay.classList.remove('overlay-open');
}

function toggleSearchOverlay() {
    const isSearchExpanded = searchToggle.getAttribute('aria-expanded') === 'true';
    isSearchExpanded ? closeSearchOverlay() : openSearchOverlay();
}

// Account overlay functions
function closeAccountOverlay(toggle, overlay) {
    if (!toggle || !overlay) return;
    toggle.setAttribute('aria-expanded', 'false');
    overlay.classList.remove('overlay-open');
}

function toggleAccountOverlay(toggle, overlay) {
    if (!toggle || !overlay) return;
    const isOverlayExpanded = toggle.getAttribute('aria-expanded') === 'true';
    const isSearchExpanded = searchToggle ? searchToggle.getAttribute('aria-expanded') === 'true' : false;
    if (isSearchExpanded) {
        closeSearchOverlay();
    }
    if (isOverlayExpanded) {
        closeAccountOverlay(toggle, overlay);
    } else {
        toggle.setAttribute('aria-expanded', 'true');
        overlay.classList.add('overlay-open');
    }
}

// Language menu functions
function openLangMenu() {
    langToggle.setAttribute('aria-expanded', 'true');
    langDropdown.hidden = false;
}

function closeLangMenu() {
    langToggle.setAttribute('aria-expanded', 'false');
    langDropdown.hidden = true;
}

function toggleLangMenu() {
    const isOpen = langToggle.getAttribute('aria-expanded') === 'true';
    isOpen ? closeLangMenu() : openLangMenu();
}

// Menu overlay functions
function openMenuOverlay() {
    const isSearchExpanded = searchToggle ? searchToggle.getAttribute('aria-expanded') === 'true' : false;
    const loggedInExpanded = loggedInToggle ?  loggedInToggle.getAttribute('aria-expanded') === 'true' : false;
    const notLoggedInExpanded = notLoggedInToggle ?  notLoggedInToggle.getAttribute('aria-expanded') === 'true' : false;

    if (isSearchExpanded) {
      closeSearchOverlay();
    }
    if (loggedInExpanded) {
      closeAccountOverlay(loggedInToggle, loggedInOverlay);
    }
    if (notLoggedInExpanded) {
      closeAccountOverlay(notLoggedInToggle, notLoggedInOverlay);
    }
    nav.classList.add('inverted');
    menuToggle.setAttribute('aria-expanded', 'true')
    menuToggle.classList.add('inverted');
    menuOverlay.hidden = false;
    menuOverlay.classList.add('overlay-open');
    closeAllLevel1Submenus();
    const focusables = getFocusableElements(menuOverlay);
    focusables[0]?.focus();
}

function closeMenuOverlay() {
    nav.classList.remove('inverted');
    menuToggle.classList.remove('inverted');
    menuToggle.setAttribute('aria-expanded', 'false');
    menuOverlay.hidden = true;
    menuOverlay.classList.remove('overlay-open');
}

function toggleMenuOverlay() {
    const isMenuExpanded = menuToggle.getAttribute('aria-expanded') === 'true';
    isMenuExpanded ? closeMenuOverlay() : openMenuOverlay();
}

// Search button interaction
searchToggle?.addEventListener('click', toggleSearchOverlay);

// Account button interaction
loggedInToggle?.addEventListener('click', () => {
    toggleAccountOverlay(loggedInToggle, loggedInOverlay);
});

notLoggedInToggle?.addEventListener('click', () => {
    toggleAccountOverlay(notLoggedInToggle, notLoggedInOverlay);
});

accountOverlayCloseButtons.forEach(button => {
    button.addEventListener('click', () => {
        if (loggedInOverlay && loggedInOverlay.classList.contains('overlay-open')) {
            closeAccountOverlay(loggedInToggle, loggedInOverlay);
        }
        if (notLoggedInOverlay && notLoggedInOverlay.classList.contains('overlay-open')) {
            closeAccountOverlay(notLoggedInToggle, notLoggedInOverlay);
        }
    });
});

// Language button interaction
langToggle?.addEventListener('click', toggleLangMenu);

// Click outside to close language dropdown
document.addEventListener('click', (event) => {
  const currentSize = getCurrentSize();
    if (currentSize === 'desktop' && langDropdown && langToggle && !langDropdown.contains(event.target) && !langToggle?.contains(event.target) && !langDropdown.hidden) {
        closeLangMenu();
    }
  })

// Menu button interaction
menuToggle.addEventListener('click', toggleMenuOverlay);

// Close overlays when Escape is pressed
document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
        if (notLoggedInToggle?.getAttribute('aria-expanded') === 'true') {
            closeAccountOverlay(notLoggedInToggle, notLoggedInOverlay);
            notLoggedInToggle.focus();
        }
        if (loggedInToggle?.getAttribute('aria-expanded') === 'true') {
            closeAccountOverlay(loggedInToggle, loggedInOverlay);
            loggedInToggle.focus();
        }
        if (searchToggle?.getAttribute('aria-expanded') === 'true') {
            closeSearchOverlay();
            searchToggle.focus();
        }
        if (langToggle?.getAttribute('aria-expanded') === 'true') {
            closeLangMenu();
            langToggle.focus();
        }
        if (menuToggle?.getAttribute('aria-expanded') === 'true') {
            closeMenuOverlay();
            menuToggle.focus();
        }
    }
    if (e.key !== 'Tab') return;
    if (menuOverlay?.classList.contains('overlay-open')) {
        loopFocus(menuOverlay, e);
    } else if (searchOverlay?.classList.contains('overlay-open')) {
        loopFocus(searchOverlay, e);
    }
});

// Focus trap function
function loopFocus(container, e) {
    const focusableElements = getFocusableElements(container);
    if (focusableElements.length === 0) return;
    const firstFocusable = focusableElements[0];
    const lastFocusable = focusableElements[focusableElements.length - 1];
    const activeElement = document.activeElement;

    // If shift+tab on first element, go to last
    if (e.shiftKey && activeElement === firstFocusable) {
        e.preventDefault();
        lastFocusable.focus();
    }
    // If tab on last element, go to first
    else if (!e.shiftKey && activeElement === lastFocusable) {
        e.preventDefault();
        firstFocusable.focus();
    }
}

//Change language position depending on device size
window.addEventListener('resize', () => {
  setTimeout(setLanguageSwitchPosition, 50)
});
setLanguageSwitchPosition();

// handle "mein-orthomol" profile avatar + popup
if (window.location.host.indexOf('orthomol') >= 0 && window.location.host.indexOf('gelenke') == -1 && window.location.pathname.indexOf('onboarding') == -1) {
    fetch('/de-de/mein-orthomol/userinfo')
    .then(response => {
        if (!response.ok) {
            throw new Error('Network response was not ok ' + response.statusText);
        }
        return response.json();
    })
    .then(data => {
        if (document.getElementById('my-orthomol-account-holder')) {
            if (data.success === true) {
                if (data.user['username']) {
                    // user is logged in
                    const usernameEl = document.getElementById('my-orthomol-username');
                    const emailEl = document.getElementById('my-orthomol-email');
                    if (usernameEl) usernameEl.textContent = data.user['username'];
                    if (emailEl) emailEl.textContent = data.user['email'];
                    document.getElementById('my-orthomol-not-logged-in')?.remove();
                    document.getElementById('my-orthomol-overlay-not-logged-in')?.remove();
                    window.loginStatus = "loggedIn";
                    if (data.user['emailHash']) {
                        pushDataLayer({
                            'event': 'hashedEmail',
                            'emailHash': data.user['emailHash']
                        });
                    }
                }
            } else {
                // not logged in
                document.getElementById('my-orthomol-logged-in')?.remove();
                document.getElementById('my-orthomol-overlay-logged-in')?.remove();
            }
            document.getElementById('my-orthomol-account-holder')?.classList.remove('d-none');
        }
    })
    .catch(error => {
        console.error('User profile data error:', error);
    });

    fetch('/de-de/fachkreise/login-status')
    .then(response => {
        if (!response.ok) {
            throw new Error('Network response was not ok ' + response.statusText);
        }
        return response.json();
    })
    .then(data => {
        if (data.success === true) {
            window.loginStatus = "loggedIn";
        }
    })
    .catch(error => {
        console.error('Fachkreise loginStatus error:', error);
    });
}

// When the user scrolls down, hide the navbar. When the user scrolls up, show the navbar
var prevScrollpos = window.pageYOffset;
window.addEventListener('scroll', function() {
  var currentScrollPos = window.pageYOffset;
  if (currentScrollPos >= 100) { // ignore actions during the first 100px (header + sticky element below)
    if (currentScrollPos > prevScrollpos) {
      if(document.getElementById('header')) { document.getElementById('header').classList.add('header-hide'); }
    } else {
      if(document.getElementById('header')) { document.getElementById('header').classList.remove('header-hide'); }
    }
    prevScrollpos = currentScrollPos;
  }
});

// Submenu toggle functionality
function submenuToggles() {
    level1Toggles();
    level2Toggles();
}

function level1Toggles() {
    const level1Items = document.querySelectorAll('.fullscreen-navi-overlay-main-level-1 > li');
    level1Items.forEach(item => {
        const button = item.querySelector('.fullscreen-navi-overlay-main-level-1-submenu-toggle');
        if (!button) return;
        button.addEventListener('click', (e) => {
            e.preventDefault();
            const isExpanded = button.getAttribute('aria-expanded') === 'true';
            if (isExpanded) {
                closeLevel1Item(item);
            } else {
                closeAllLevel1Submenus();
                openLevel1Item(item);
            }
        });
    });
}

function level2Toggles() {
    const level2Items = document.querySelectorAll('.fullscreen-navi-overlay-main-level-2 > li');

    level2Items.forEach(item => {
        const button = item.querySelector('.fullscreen-navi-overlay-main-level-2-submenu-toggle');
        if (!button) return;
        button.addEventListener('click', (e) => {
            e.preventDefault();
            const isExpanded = button.getAttribute('aria-expanded') === 'true';
            if (isExpanded) {
                closeLevel2Item(item);
            } else {
                closeAllLevel2Submenus();
                openLevel2Item(item);
            }
        });
    });
}

// Level 1 functions
function openLevel1Item(item) {
    const button = item.querySelector('.fullscreen-navi-overlay-main-level-1-submenu-toggle');
    const submenu = item.querySelector('.fullscreen-navi-overlay-main-level-2');
    const link = item.querySelector('a');

    if (button && submenu) {
        button.setAttribute('aria-expanded', 'true');
        submenu.removeAttribute('hidden');
        if (link) link.classList.add('active');
    }
}

function closeLevel1Item(item) {
    const button = item.querySelector('.fullscreen-navi-overlay-main-level-1-submenu-toggle');
    const submenu = item.querySelector('.fullscreen-navi-overlay-main-level-2');
    const link = item.querySelector('a');

    if (button && submenu) {
        button.setAttribute('aria-expanded', 'false');
        submenu.setAttribute('hidden', '');
        if (link) link.classList.remove('active');

        const level2Items = submenu.querySelectorAll('li');
        level2Items.forEach(level2Item => {
            closeLevel2Item(level2Item);
        });
    }
}

function closeAllLevel1Submenus() {
    const level1Items = document.querySelectorAll('.fullscreen-navi-overlay-main-level-1 > li');
    level1Items.forEach(item => {
        closeLevel1Item(item);
    });
}

// Level 2 helper functions
function openLevel2Item(item) {
    const button = item.querySelector('.fullscreen-navi-overlay-main-level-2-submenu-toggle');
    const submenu = item.querySelector('.fullscreen-navi-overlay-main-level-3');
    const link = item.querySelector('a');

    if (button && submenu) {
        button.setAttribute('aria-expanded', 'true');
        submenu.removeAttribute('hidden');
        if (link) link.classList.add('active');
    }
}

function closeLevel2Item(item) {
    const button = item.querySelector('.fullscreen-navi-overlay-main-level-2-submenu-toggle');
    const submenu = item.querySelector('.fullscreen-navi-overlay-main-level-3');
    const link = item.querySelector('a');

    if (button && submenu) {
        button.setAttribute('aria-expanded', 'false');
        submenu.setAttribute('hidden', '');
        if (link) link.classList.remove('active');
    }
}

function closeAllLevel2Submenus() {
    const level2Items = document.querySelectorAll('.fullscreen-navi-overlay-main-level-2 > li');
    level2Items.forEach(item => {
        closeLevel2Item(item);
    });
}

document.addEventListener('DOMContentLoaded', submenuToggles);
